<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="relative">
    <div class="vx-navbar-wrapper">
      <vs-navbar class="vx-navbar navbar-custom" :color="navbarColor" :class="classObj">
        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon class="sm:inline-flex xl:hidden cursor-pointer mr-1" icon="MenuIcon"
                      @click.stop="showSidebar"></feather-icon>

        <template v-if="breakpoint != 'md'">
        </template>

        <vs-spacer></vs-spacer>
        <ChangeLanguage></ChangeLanguage>
        <feather-icon v-if="$acl.check('editor')" icon="SearchIcon"
                      @click="showFullSearch = true"
                      class="cursor-pointer navbar-fuzzy-search ml-4"></feather-icon>
        <vs-checkbox  v-if="this.$systemSettings && this.$systemSettings.AllowAiSearch" v-model="searchWithAi">{{ $t('SearchWithAI') }}</vs-checkbox>


        <!-- SEARCHBAR -->
        <div v-if="$acl.check('editor')" style="margin-right:20px;" class="search-full-container w-full h-full absolute left-0 rounded-lg" :class="{'flex': showFullSearch}" v-show="showFullSearch">
          <vx-auto-suggest class="w-full"
                           inputClassses="w-full vs-input-no-border vs-input-no-shdow-focus no-icon-border"
                           :autoFocus="showFullSearch"
                           :data="navbarSearchAndPinList"
                           icon="SearchIcon"
                           :frontendFilter="false" :searchLimit="30"
                           :placeholder="$t('SearchPlaceholderNavbar')"
                           ref="navbarSearch"
                           @queryChanged="ReSearchHandler"
                           @closeSearchbar="showFullSearch = false"
                           @selected="selected"
                           background-overlay />
          <div class="absolute right-0 h-full z-50">
            <feather-icon icon="XIcon" class="px-4 cursor-pointer h-full close-search-icon" @click="showFullSearch = false"></feather-icon>
          </div>
        </div>

        <div class="flex items-top" v-if="lockedProject != null && lockedProject.Id">
          <div class="text-left leading-tight sm:block; mr-5">
            <small>
              <strong v-if="lockedProject && lockedProject.Id">
                <a :href="'/dashboard/projects/' + lockedProject.Id + '/details'">{{ lockedProject.Title }}</a>
              </strong>
            </small>
          </div>
        </div>
        <div class="text-right leading-tight sm:block">
          <vs-dropdown class="vx-navbar-dropdown accounts-wrapper" vs-custom-content vs-trigger-click
                       style="cursor:pointer;">
            <small>
              <vs-avatar v-if="userProfile" style="float:left;" :src="userProfile.avatarUrl" color="success" text-color="white" :text="getFriendlyUserName(userProfile.UserName)" />
              <strong>{{ user_displayName }}</strong>
              <br />
            </small>
            <span></span>
            <ul style="" v-if="true">
              <vs-dropdown-menu class="vx-navbar-dropdown" style="min-width: 250px;">
                <!--<li v-for="acc in userAccounts" :key="acc.Id"
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="changeAccount(acc.Account.Id)">
            <img v-if="acc &&
                        acc.Account &&
                        acc.Account.AccountBranding &&
                        acc.Account.AccountBranding.MainLogoUrl &&
                        acc.Account.AccountBranding.MainLogoUrl" :src="acc.Account.AccountBranding.MainLogoUrl"
              style="height:24px; max-width:24px; overflow:hidden; border-radius:10px; margin-right:5px;" />
            </span>
            <div>
              {{ acc.Account.AccountName }}
            </div>
          </li>-->
                <li class="flex py-2 px-4 cursor-pointer">
                  <a href="/pages/profile">{{ $t('Profile') }}</a>
                </li>
                <li class="flex py-2 px-4 cursor-pointer">
                  <a href="/licensing/catalog">{{ $t('TCVelikLicensing') }}</a>
                </li>
                <li v-if="$acl.check('admin')" class="flex py-2 px-4 cursor-pointer">
                  <a href="/account/users">{{ $t('ManageUsers') }}</a>
                </li>
                <li v-if="$acl.check('admin')" class="flex py-2 px-4 cursor-pointer">
                  <a href="/admin/accounts">{{ $t('AccountAdmin') }}</a>
                </li>
                <li v-if="$acl.check('admin')" class="flex py-2 px-4 cursor-pointer">
                  <a href="/admin/branding">{{ $t('AccountBranding') }}</a>
                </li>
                <li class="flex py-2 px-4 cursor-pointer">
                  <a href="#" @click.stop="logout">{{ $t('Logout') }}</a>
                </li>
              </vs-dropdown-menu>
            </ul>
          </vs-dropdown>
        </div>
        <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
          <div class="con-img ml-3">
            <!--<UserAvatar v-if="userProfile" :userProfile="userProfile" size="32px" color="primary"
        class="user-profile-main">
      </UserAvatar>-->
          </div>
          <vs-dropdown-menu class="vx-navbar-dropdown">
            <ul style="min-width: 9rem">
              <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white profile-link"
                  @click="GoToProfile()">
                <!-- <a
            class="profile-link"
            :href="`/pages/profile/${getUserSlug()}`"
          > -->
                <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
                <span class="ml-2">{{ $t('Profile') }}</span>
                <!-- </a> -->
              </li>
              <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                  @click.stop="$router.push(href = '/dashboard/knowledge-tree')">
                <feather-icon icon="AwardIcon" svgClasses="w-4 h-4 " style="" />
                <span class="ml-2">{{ $t('Skills') }}</span>
              </li>
              <li v-if="$acl.check('admin')" class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                  @click.stop="$router.push(href = '/cloud-admin/maintenance')">
                <feather-icon icon="SettingsIcon" svgClasses="w-4 h-4 " style="" />
                <span class="ml-2">{{ $t('Admin') }}</span>
              </li>
              <li v-if="$acl.check('admin')" class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                  @click.stop="$router.push(href = '/account/users')">
                <feather-icon icon="UsersIcon" svgClasses="w-4 h-4 " style="" />
                <span class="ml-2">{{ $t('Users') }}</span>
              </li>
              <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" v-if="isVisualStudio"
                  @click="LockProject()">
                <feather-icon icon="LockIcon" svgClasses="w-4 h-4" />
                <span class="ml-2">{{ $t('Focus') }}</span>
              </li>

              <vs-divider class="m-1"></vs-divider>

              <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="logout">
                <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
                <span class="ml-2">{{ $t('Logout') }}</span>
              </li>
            </ul>
          </vs-dropdown-menu>
        </vs-dropdown>

        <!-- NOTIFICATIONS -->
        <!--<vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <feather-icon icon="BellIcon" class="cursor-pointer mt-1 sm:mr-6 mr-2"
        :badge="unreadNotifications.length"></feather-icon>
      <vs-dropdown-menu class="notification-dropdown dropdown-custom vx-navbar-dropdown">
        <div class="notification-top text-center p-5 bg-primary text-white">
          <h3 class="text-white">{{ unreadNotifications.length }} New</h3>
          <p class="opacity-75">App Notifications</p>
        </div>

        <VuePerfectScrollbar ref="mainSidebarPs" class="scroll-area--nofications-dropdown p-0 mb-10"
          :settings="settings">
          <ul class="bordered-items">
            <li v-for="ntf in unreadNotifications" :key="ntf.index"
              class="flex justify-between px-4 py-4 notification cursor-pointer">
              <div class="flex items-start">
                <feather-icon :icon="ntf.icon" :svgClasses="[
    `text-${ntf.category}`,
    'stroke-current mr-1 h-6 w-6',
  ]"></feather-icon>
                <div class="mx-2">
                  <span class="font-medium block notification-title" :class="[`text-${ntf.category}`]">{{ ntf.title
                    }}</span>
                  <small>{{ ntf.msg }}</small>
                </div>
              </div>
              <small class="mt-1 whitespace-no-wrap">{{
    elapsedTime(ntf.time)
  }}</small>
            </li>
          </ul>
        </VuePerfectScrollbar>
        <div
          class="checkout-footer fixed bottom-0 rounded-b-lg text-primary w-full p-2 font-semibold text-center border border-b-0 border-l-0 border-r-0 border-solid d-theme-border-grey-light cursor-pointer">
          <span>View All Notifications</span>
        </div>
      </vs-dropdown-menu>
    </vs-dropdown>-->
        <!-- USER META -->
      </vs-navbar>
    </div>
  </div>
</template>

<script>
  // import firebase from 'firebase/app'
  import { AclRule } from 'vue-acl'
  import "firebase/auth";
  import VxAutoSuggest from "@/components/vx-auto-suggest/VxAutoSuggest.vue";
  import VuePerfectScrollbar from "vue-perfect-scrollbar";
  import draggable from "vuedraggable";
  import TCVelikClient from "@/TCVelikClient/TCVelikClient.js";
  import UserAvatar from "@/views/components/extra-components/users/UserAvatar.vue";
  import ChangeLanguage from "@/views/components/extra-components/language/ChangeLanguage.vue";
  import AccountsService from '@/accounts/accountsService.js';
  import FeatherIcon from "@/components/FeatherIcon.vue";
  import accountsService from "../../accounts/accountsService";

  export default {
    name: "the-navbar",
    debounceTimeout: null,
    props: {
      navbarColor: {
        type: String,
        default: "#fff",
      },
    },
    mounted() {
      var $ = window.$;
      var instance = this;

      // instance.navbarSearchAndPinList.data = [];

      this.$store.dispatch("updatateNavbarSearchAndPinList", []);

      try {
        var profile = JSON.parse(accountsService.getUserFromLocalStorage());
        this.$set(this, "userProfile", profile.User);
      } catch (err) {
        console.log(err);
      }

      try {
        var projectAsJsonStr = localStorage.getItem("projectContext");
        if (projectAsJsonStr && projectAsJsonStr.length > 0) {
          var jsonProj = JSON.parse(projectAsJsonStr);
          this.$set(this, "lockedProject", jsonProj);
        }
      } catch (err) {
        console.log("Error getting focussed project.");
      }

      try {
        $.connection.tCApiHub.on("DocumentUpdated", function (context) {
          // alert('Updated', context);
        });
        $.connection.tCApiHub.on("BroadcastMessage", function (context) {
          if (instance.unreadNotifications.length > 10) {
            instance.unreadNotifications = [];
          }
          if (context.Message) {
            if (context.MessageId == "INDEX_COMPLETE") {
              var projectName = "";
              if (context.Context && context.Context.Name) {
                projectName = context.Context.Name;
              }
              instance.unreadNotifications.splice(0, 0, {
                index: instance.unreadNotifications.lenght,
                title: instance.$t('AnalysisCompleted'),
                msg: instance.$t('ProjectWasAnalyzed', { projectName: projectName }),
                category: "success",
                icon: "PackageIcon",
                time: new Date().toString(),
              });
            } else if (context.MessageId === "INDEX_REQUESTED") {
              instance.unreadNotifications.splice(0, 0, {
                index: instance.unreadNotifications.lenght,
                title: instance.$t('AnalysisStarted'),
                msg: context.Message,
                category: "success",
                icon: "PackageIcon",
                time: new Date().toString(),
              });
            } else if (context.MessageId == "CACHE_REFRESH") {
              instance.unreadNotifications.splice(0, 0, {
                index: instance.unreadNotifications.lenght,
                title: instance.$t('AnalysisStarted'),
                msg: context.Message,
                category: "success",
                icon: "PackageIcon",
                time: new Date().toString(),
              });
            } else if (context.MessageId == "PROCESSING_FILE") {
              instance.unreadNotifications.splice(0, 0, {
                index: instance.unreadNotifications.lenght,
                title: instance.$t('AnalysisWithTitle', { title: context.Context.Title }),
                msg: context.Message,
                category: "success",
                icon: "PackageIcon",
                time: new Date().toString(),
              });
            } else if (context.Message) {
              instance.unreadNotifications.splice(0, 0, {
                index: instance.unreadNotifications.lenght,
                title: instance.$t('AnalysisStarted'),
                msg: context.Message,
                category: "success",
                icon: "PackageIcon",
                time: new Date().toString(),
              });
            }
          }
        });
      }
      catch (err) {
        console.log("Error with hubs.");
      }
    },
    data() {
      return {
        navbarSearchAndPinList: this.$store.state.navbarSearchAndPinList,
        searchQuery: "",
        showFullSearch: false,
        unreadNotifications: [],
        lockedProject: null,
        searchWithAi: false,
        settings: {
          // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: 0.6,
        },
        autoFocusSearch: false,
        showBookmarkPagesDropdown: false,
        userAccounts: TCVelikClient.getAllAccounts(),
        selectedAccountId: TCVelikClient.getSelectedAccountId(),
        userProfile: null,
      };
    },



    computed: {
      // HELPER
      sidebarWidth() {
        return this.$store.state.sidebarWidth;
      },
      breakpoint() {
        return this.$store.state.breakpoint;
      },

      isVisualStudio() {
        return this.$store.state.IsVisualStudio;
      },

      // NAVBAR STYLE
      classObj() {
        if (this.sidebarWidth == "default") return "navbar-default";
        else if (this.sidebarWidth == "reduced") return "navbar-reduced";
        else if (this.sidebarWidth) return "navbar-full";
      },

      // I18N
      getCurrentLocaleData() {
        const locale = this.$i18n.locale;
        if (locale == "en") return { flag: "us", lang: this.$t('English') };
        else if (locale == "pt") return { flag: "br", lang: this.$t('Portuguese') };
        else if (locale == "fr") return { flag: "fr", lang: this.$t('French') };
        else if (locale == "de") return { flag: "de", lang: this.$t('German') };
      },

      // BOOKMARK & SEARCH
      data() {
        return this.$store.state.navbarSearchAndPinList;
      },
      starredPages() {
        return this.$store.state.starredPages;
      },
      starredPagesLimited: {
        get() {
          return this.starredPages.slice(0, 10);
        },
        set(list) {
          this.$store.dispatch("arrangeStarredPagesLimited", list);
        },
      },
      starredPagesMore: {
        get() {
          return this.starredPages.slice(10);
        },
        set(list) {
          this.$store.dispatch("arrangeStarredPagesMore", list);
        },
      },

      // CART DROPDOWN
      cartItems() {
        return this.$store.state.eCommerce.cartItems.slice().reverse();
      },

      // PROFILE
      user_displayName() {
        var userInfo = JSON.parse(localStorage.getItem(location.hostname + '-fullUserInfo'));
        if (
          userInfo &&
          userInfo.User &&
          userInfo.User.firstName &&
          userInfo.User.lastName
        ) {
          return userInfo.User.firstName + " " + userInfo.User.lastName;
        }
        else if (userInfo.User && userInfo.User.UserName) {
          return this.getFriendlyUserName(userInfo.User.UserName);
        }
        else {
          return this.$t('NoInfo');
        }
      },



      selectedAccount() {
        return TCVelikClient.getSelectedAccount().AccountName;
      },

      user_account() {
        var userInfo = accountsService.getUserFromLocalStorage();
        if (userInfo && userInfo.Account && userInfo.Account.AccountName) {
          return userInfo.Account.AccountName;
        } else {
          return this.$t('UnknownAccount');
        }
      },
      activeUserImg() {
        var profileInfo = accountsService.getUserFromLocalStorage().user;
        return profileInfo.UserImageUrl;
      },
    },
    methods: {
      updateLocale(locale) {
        this.$i18n.locale = locale;
      },

      ReSearchHandler(evt) {
        clearTimeout(this.debounceTimeout);
        if (evt.length < 3) {
          return;
        }
        this.debounceTimeout = setTimeout(() => {
          this.ReSearch(evt);
        }, 500);
      },


      AskAiForIntent(evt) {
        return new Promise((resolve, reject) => {
          var instance = this;
          var documentCopy = document.cloneNode(true);
          var steps = documentCopy.getElementsByClassName("content");
          var result = [];

          var payload = {
            InputTokens: 0,
            OutputTokens: 0,
            Messages: [
              {
                Role: "System",
                Content: "You must return the result as JAVASCRIPT OBJECT.DO NOT SPLIT THE VECTORS INTO A  SUB-OBJECT.THE VECTORS CAN HAVE MULTIPLE VALUES SO PUT THEM IN AN ARRAY.DO NOT ADD A 'json' STRING IN THE BEGINNING.YOU MUST NOT PUT THE RESULT IN A STRING.DO NOT PROVIDE EXTRA EXPLAINATIONS.DO NOT RETURN EMPTY VECTORS AT ALL.IF YOU CANNOT EXTRACT ANYTHING RETURN AN EMPTY OBJECT.You are helping categorize and infer intent from a search query to improve discoverability, contextual relevance, and assistant suggestions.You must return the result as a JSON object.Given an SOP (including its title, description, steps, and optionally metadata), extract and assign the following vectors:\n Primary Vectors to Extract:System – What platform or tool is the SOP related to?(e.g., Sitefinity, Azure DevOps, Outlook, Power Automate, etc.)\nClient – Which organization or customer this SOP is specific to?(e.g., Eveliko, KAUST, Dubai Airports, or leave blank if generic)\nProject – Which project within the client it relates to, if applicable.(e.g Student Portal, SharePoint Migration, etc.)\nRole – Who is expected to perform this SOP ?(e.g., Developer, Editor, Compliance Officer, Admin)\nSecondary Vectors to Extract(if detectable):\nActionType– What is the user doing ?(e.g., Create, Edit, Approve, Deploy, Review, Submit)\nLifecycleStage– Where does this SOP fit in the bigger picture ?(e.g., Onboarding, Audit Prep, Release Planning, Support Response)\n Technology – Granular tooling beyond the system(optional but useful).(e.g., Azure Pipelines, Teams Chat, Graph API, Razor Views)\n Environment – Where is this performed ?(e.g., Production, QA, Dev, Local, Staging)\n Persona – What kind of person is this designed for?(e.g., Junior Developer, Project Manager, Trainee)\n Frequency – How often is this done ?(e.g., One - time, Monthly, On Event, Daily Task)\n SensitivityLevel – Does it involve confidential or regulated data(e.g., PII, Internal Only, IT Access Required) "
              },
              {
                Role: "User",
                Content: evt
              }]
          };


          var options = {
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
            }
          };

          TCVelikClient.PostRelative("/api/OpenAI/ChatWithFunctions", payload, options).then(function (response) {
            if (response && response.data && response.data) {

              try {
                var newText = JSON.parse(response.data.Messages[response.data.Messages.length - 1].Content);
                resolve(JSON.parse(newText[0].Text))
              }
              catch (err) {
                reject('Something happened...');
              }
            }
          });
        })


      },

      async ReSearch(evt) {
        var isInChrome = document.body.getAttribute("notcv") == "true";
        var body_req = null
        if (this.searchWithAi) {
          var body_req = await this.AskAiForIntent(evt);
        }
        var instance = this;
        TCVelikClient.PostRelative("/api/SearchWithIntent?query=*" + evt + "*&shortResults=true&urlContext=",body_req)
          .then(function (result) {
            var massaged = result.data.map(function (itm) {
              return {
                label: itm.Name,
                url: isInChrome ? "/pages/liveguide/" + itm.Id : "/pages/pdf-view?oid=" + itm.Id,
                image: itm.FirstImage
              }
            });

            instance.$store.dispatch("updatateNavbarSearchAndPinList", massaged);
          });
      },
      getFriendlyUserName(userNameCandidate) {
        // Remove domain part if '@' is present
        let namePart = userNameCandidate.split('@')[0];

        // Replace '.' with ' '
        namePart = namePart.replace(/\./g, ' ');

        // Capitalize first letters
        namePart = namePart.replace(/\b\w/g, char => char.toUpperCase());

        return namePart;
      },
      showSidebar() {
        this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", true);
      },
      selected(item) {
        this.$router.push(item.url);
        this.showFullSearch = false;
      },
      actionClicked(item) {
        // e.stopPropogation();
        this.$store.dispatch("updateStarredPage", {
          index: item.index,
          val: !item.highlightAction,
        });
      },
      showNavbarSearch() {
        this.showFullSearch = true;
      },
      showSearchbar() {
        this.showFullSearch = true;
      },
      getUserSlug() {
        var slug = accountsService.getUserFromLocalStorage().user.slug;
        if (slug && slug.length > 0) {
          return slug;
        } else {
          alert(
            this.$t('UserDoesNotHaveSlug')
          );
        }
      },
      elapsedTime(startTime) {
        let x = new Date(startTime);
        let now = new Date();
        var timeDiff = now - x;
        timeDiff /= 1000;

        var seconds = Math.round(timeDiff);
        timeDiff = Math.floor(timeDiff / 60);

        var minutes = Math.round(timeDiff % 60);
        timeDiff = Math.floor(timeDiff / 60);

        var hours = Math.round(timeDiff % 24);
        timeDiff = Math.floor(timeDiff / 24);

        var days = Math.round(timeDiff % 365);
        timeDiff = Math.floor(timeDiff / 365);

        var years = timeDiff;

        if (years > 0) {
          return this.$t(years > 1 ? 'YearsAgo' : 'YearAgo', { 
            years: years, 
            yearsText: this.$t('Years') 
          });
        } else if (days > 0) {
          return this.$t(days > 1 ? 'DaysAgoSidebar' : 'DaysAgoSidebar', { 
            days: days, 
            daysText: this.$t('Days') 
          });
        } else if (hours > 0) {
          return this.$t(hours > 1 ? 'HoursAgo' : 'HourAgo', { 
            hours: hours, 
            hoursText: this.$t('Hours') 
          });
        } else if (minutes > 0) {
          return this.$t(minutes > 1 ? 'MinutesAgo' : 'MinuteAgo', { 
            minutes: minutes, 
            minutesText: this.$t('Min') 
          });
        } else if (seconds > 0) {
          return this.$t('SecondsAgo', { seconds: seconds });
        }

        return this.$t('JustNow');
      },
      logout() {
        // if user is logged in via auth0
        // Change role on logout. Same value as initialRole of acj.js
        this.$acl.change("admin");
        AccountsService.cleanUserLocalStorageItems();
        window.location.href = "/pages/login";
        // this.$router.push("/pages/login");
      },
      outside: function () {
        this.showBookmarkPagesDropdown = false;
      },

      GoToProfile() {
        //this.$router.push(`/pages/profile/${this.getUserSlug()}`);
        this.$router.push(`/pages/profile`);
      },

      changeAccount(accountId) {
        TCVelikClient.changeAccount(accountId);
      },

      // CART DROPDOWN
      removeItemFromCart(item) {
        this.$store.dispatch("eCommerce/toggleItemInCart", item);
      },

      isProjectFocussed() {
        var focussedProjectStr = localStorage.getItem("projectContext");
        return focussedProjectStr != null && focussedProjectStr.length > 0;
      },
    },
    directives: {
      "click-outside": {
        bind: function (el, binding) {
          const bubble = binding.modifiers.bubble;
          const handler = (e) => {
            if (bubble || (!el.contains(e.target) && el !== e.target)) {
              binding.value(e);
            }
          };
          el.__vueClickOutside__ = handler;
          document.addEventListener("click", handler);
        },

        unbind: function (el) {
          document.removeEventListener("click", el.__vueClickOutside__);
          el.__vueClickOutside__ = null;
        },
      },
    },
    components: {
      VxAutoSuggest,
      VuePerfectScrollbar,
      draggable,
      UserAvatar,
      ChangeLanguage,
      FeatherIcon,
    },
  };
</script>
<style scoped>
  * > > > .profile-link {
    color: black;
  }

    * > > > .profile-link:hover {
      color: white;
    }
</style>
